import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { NgSelectModule } from '@ng-select/ng-select';

import { registrationRouting } from './registration.routes';

import { AdminComponent } from './admin/admin.component';
import { DirectorComponent } from './director/director.component';
import { RegistrationComponent } from './registration.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';

/* Shared Components */
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { FiscalCodeService } from '@shared/services/fiscal-code.service';
import { SharedModule } from "@shared/shared.module";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ApplicantPreIdvPageComponent } from './applicant-pre-idv-page/applicant-pre-idv-page.component';
import { BeneficialOwnerChoiceComponent } from './beneficial-owner-choice/beneficial-owner-choice.component';
import { BeneficialOwnerFormComponent } from './beneficial-owners/beneficial-owner-form/beneficial-owner-form.component';
import { BeneficialOwnersComponent } from './beneficial-owners/beneficial-owners.component';
import { CompanyStepModule } from './company-step/company-step.module';
import { ExpectedActivityStepModule } from './expected-activity-step/expected-activity-step.module';
import { NavigationComponent } from './navigation/navigation.component';
import { PersonFormHelperService } from './person-form/person-form-helper.service';
import { PersonFormComponent } from './person-form/person-form.component';
import { SignupStepModule } from './signup-step/signup-step.module';
import { UppercaseDirective } from '@shared/directives/uppercase.directive';
import { ApplicantPreDotfilePageComponent } from './applicant-pre-dotfile-page/applicant-pre-dotfile-page.component';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelectModule,
        SharedModule,
        SignupStepModule,
        CompanyStepModule,
        ExpectedActivityStepModule,
        registrationRouting,
        UppercaseDirective,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    declarations: [
        RegistrationComponent,
        NavigationComponent,
        DirectorComponent,
        AdminComponent,
        TermsConditionComponent,
        ClickOutsideDirective,
        BeneficialOwnersComponent,
        BeneficialOwnerChoiceComponent,
        BeneficialOwnerFormComponent,
        PersonFormComponent,
        ApplicantPreIdvPageComponent,
        ApplicantPreDotfilePageComponent
    ],
    providers: [
        FiscalCodeService,
        PersonFormHelperService,
        provideNgxMask()
    ]
})
export class RegistrationModule { }
